import { h } from "@stencil/core";
import { getSvgContent, iconContent } from "./requests";
export class ChIcon {
    constructor() {
        this.color = undefined;
        this.lazy = false;
        this.autoColor = false;
        this.src = "";
        this.size = "regular";
        this.isVisible = false;
        this.svgContent = undefined;
    }
    io;
    element;
    /** *******************************
    METHODS
    *********************************/
    connectedCallback() {
        // purposely do not return the promise here because loading
        // the svg file should not hold up loading the app
        // only load the svg if it's visible
        this.waitUntilVisible(this.element, "50px", () => {
            this.isVisible = true;
            this.getIcon();
        });
    }
    disconnectedCallback() {
        if (this.io !== undefined) {
            this.io.disconnect();
            this.io = undefined;
        }
    }
    waitUntilVisible(el, rootMargin, callback) {
        if (this.lazy &&
            typeof window !== "undefined" &&
            window.IntersectionObserver) {
            const io = (this.io = new window.IntersectionObserver((data) => {
                if (data[0].isIntersecting) {
                    io.disconnect();
                    this.io = undefined;
                    callback();
                }
            }, { rootMargin }));
            io.observe(el);
        }
        else {
            // browser doesn't support IntersectionObserver
            // so just fallback to always show it
            callback();
        }
    }
    async getIcon() {
        if (this.isVisible) {
            if (this.src) {
                if (iconContent.has(this.src)) {
                    this.svgContent = iconContent.get(this.src);
                }
                else {
                    this.svgContent = await getSvgContent(this.src);
                }
            }
            else {
                this.svgContent = "";
                return;
            }
        }
    }
    render() {
        return h("div", { innerHTML: this.svgContent });
    }
    static get is() { return "ch-icon"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["icon.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["icon.css"]
        };
    }
    static get assetsDirs() { return ["ch-icon-assets"]; }
    static get properties() {
        return {
            "color": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "Color",
                    "resolved": "\"alwaysblack\" | \"auto\" | \"disabled\" | \"error\" | \"negative\" | \"onbackground\" | \"ondisabled\" | \"primary-active\" | \"primary-enabled\" | \"primary-hover\" | \"success\" | \"warning\"",
                    "references": {
                        "Color": {
                            "location": "local",
                            "path": "/home/runner/work/chameleon-controls-library/chameleon-controls-library/src/components/icon/icon.tsx",
                            "id": "src/components/icon/icon.tsx::Color"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The color of the icon."
                },
                "attribute": "color",
                "reflect": false
            },
            "lazy": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If enabled, the icon will be loaded lazily when it's visible in the viewport."
                },
                "attribute": "lazy",
                "reflect": false,
                "defaultValue": "false"
            },
            "autoColor": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If enabled, the icon will display its inherent/natural color"
                },
                "attribute": "auto-color",
                "reflect": true,
                "defaultValue": "false"
            },
            "src": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The URL of the icon."
                },
                "attribute": "src",
                "reflect": true,
                "defaultValue": "\"\""
            },
            "size": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "Size",
                    "resolved": "\"regular\" | \"small\"",
                    "references": {
                        "Size": {
                            "location": "local",
                            "path": "/home/runner/work/chameleon-controls-library/chameleon-controls-library/src/components/icon/icon.tsx",
                            "id": "src/components/icon/icon.tsx::Size"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The size of the icon. Possible values: regular, small."
                },
                "attribute": "size",
                "reflect": false,
                "defaultValue": "\"regular\""
            }
        };
    }
    static get states() {
        return {
            "isVisible": {},
            "svgContent": {}
        };
    }
    static get elementRef() { return "element"; }
    static get watchers() {
        return [{
                "propName": "src",
                "methodName": "getIcon"
            }];
    }
}
//# sourceMappingURL=icon.js.map
